/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import React from "react"

import {Wave} from "react-css-spinners"

const CenteredLoading = () => {
    return (
        <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
            <Wave color="#00425A" />
        </div>
    )
}

export default CenteredLoading
